import React from "react";

/**
 * Wraps every panel to catch render errors and log them to /api/v1/analytics/track.
 * Prevents whole app from white-screening; shows a friendly error card and lets user
 * report + retry.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    this.setState({ info });
    // Best-effort remote log — never throw from logger
    try {
      const backend = process.env.REACT_APP_BACKEND_URL;
      if (backend) {
        fetch(`${backend}/api/v1/analytics/track`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            type: "frontend_error",
            path: window.location.pathname,
            meta: {
              message: String(error?.message || error),
              stack: String(error?.stack || "").slice(0, 2000),
              component: String(info?.componentStack || "").slice(0, 2000),
              user_agent: navigator.userAgent,
            },
          }),
        }).catch(() => {});
      }
    } catch {}
    // Console for dev
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="p-8 max-w-2xl mx-auto" data-testid="error-boundary">
        <div className="rounded-xl border border-destructive/40 bg-destructive/5 p-6">
          <div className="font-display font-bold text-xl mb-2">Bir şeyler ters gitti</div>
          <p className="text-sm text-muted-foreground mb-4">
            Bu sayfa yüklenirken beklenmeyen bir hata oluştu. Ekip otomatik olarak bilgilendirildi.
          </p>
          <pre className="text-xs bg-muted p-3 rounded overflow-auto max-h-40 mb-3">
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <div className="flex gap-2">
            <button className="px-3 py-2 rounded bg-primary text-primary-foreground text-sm" onClick={() => window.location.reload()}>Sayfayı Yenile</button>
            <button className="px-3 py-2 rounded border border-border text-sm" onClick={() => window.history.back()}>Geri Dön</button>
          </div>
        </div>
      </div>
    );
  }
}
